export default "__VITE_ASSET__fecd57f9__"